import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class NewsletterSubscribeRequest {
  @jsonMember(String)
  public readonly email!: string;

  public constructor(
    private readonly data: {
      email: string;
    },
  ) {
    this.email = this.data.email;
  }
}
